import * as serviceWorkerRegistration from './serviceWorkerRegistration';

require.context('../images', true);
const importAll = (r) => r.keys().forEach(r);

import 'bootstrap';

import '../javascripts/common/cookiechoices';

importAll(require.context('.', true, /companion\.(t|j)s$/));

import ReactOnRails from 'react-on-rails';
import App from '../bundles/App';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  App,
});

serviceWorkerRegistration.register();
